import { render, staticRenderFns } from "./StockTakeDetail.vue?vue&type=template&id=a8a93d28&lang=pug&"
import script from "./StockTakeDetail.vue?vue&type=script&lang=js&"
export * from "./StockTakeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports